import qs from 'qs'
import axios from '@/api/apiClient'
/**
 * 推送api
 */
const api = {
  // 通知列表
  getPushMessage: '/api/member/pushmessagelog/pc/page',
  // 获取站内信列表
  getSysMsgList: '/api/sysmessage/page',
  getSysMsgUnRead: '/api/sysmessage/unReadNum',
  // 用户洽谈列表
  getChatList: '/api/talkMessageLog/page',
  // 游客登录
  getVisitorInfo: '/api/talkMessageLog/visitor/username',
  // 移除未读消息
  removeUnread: '/api/talkMessageLog/remove/unread',
  // 站内信详情
  getSysMsgDetail: '/api/sysmessage/detail',
  // 阅读全部站内信
  toReadAll: '/api/sysmessage/toReadAll',

  // 洽谈未读消息数
  msgUnReadNum: '/api/member/myinfo/message/unReadNum',
}

export default api

/**
 * 查询"通知"列表
 * @interface https://api-test.yunhzh.com:9999/swagger-ui.html?urls.primaryName=yunhzh-upms-api#/
 * @param {*} query
 */
export const getPushMessage = (query) => {
  return axios.$get(`${api.getPushMessage}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 移除未读消息
 * @param {*} query
 * from String 消息发送者会员unicode
 * to String 消息接收者会员unicode
 * */
export const removeUnread = (query) => {
  return axios.$delete(`${api.removeUnread}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 查询游客username
 * @interface https://api-test.yunhzh.com:9999/swagger-ui.html?urls.primaryName=yunhzh-upms-api#/
 * @param {*} query
 */
export const getVisitorInfo = (query) => {
  return axios.$get(`${api.getVisitorInfo}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 站内信列表
export const getSysmsgList = (query) => {
  return axios.$get(`${api.getSysMsgList}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取用户站内信未读数量
export const getSysMsgUnRead = (query) => {
  return axios.$get(`${api.getSysMsgUnRead}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * @description: 一键已读全部站内信
 * @param {*}
 * @return {*}
 */
export const toReadAll = (param) => {
  return axios.$post(`${api.toReadAll}`, param)
}

// 获取系统详情
export const getSysmsgDetail = (id) => {
  return axios.$get(`${api.getSysMsgDetail}/${id}`)
}

// 设置洽谈列表
export const setSaveChat = (param) => {
  return axios.$post('/api/talkMessageLog/save', param)
}

/**
 * 获取洽谈列表
 * @returns {Object} memberCardVO 当前登录者的信息
 * @returns {Object} talkMessageLog 最后一条发送的消息, 和发送者的信息
 * @returns {Object} toMemberCardVO
 */
export const getChatList = (query) => {
  return axios.$get(`${api.getChatList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 获取单聊消息历史记录
 * @param {*} query.contentType 消息类型 txt、img、loc、audio、video、file、product、card
 * @param {*} query.unicode  直播code
 * @param {*} query.toMemberCode 对方会员code
 * @param {*} query.current 当前页
 * @param {*} query.size 每页条数
 * @param {*} query.startTime 开始时间
 * @param {*} query.endTime 结束时间
 * @returns
 */
export const getChatHistory = (query) => {
  return axios.$get(`/api/myChatHistory/chat/history${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * @description: 获取用户消息中心未读数量
 * @param {*}
 * @return {Integer} sysUnReadNum 站内信未读数
 * @return {Integer} allUnReadNum 消息中心未读数(未读总数)
 * @return {Integer} noticeUnReadNum 消息推送的, PC端不用理会
 * @return {Integer} talkUnReadNum 洽谈未读数
 */
export const getMsgUnReadNum = (query) => {
  return axios.$get(`${api.msgUnReadNum}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * @description: 同步洽谈未读数
 * @param {Number} unReadNum 未读数
 * @return {*}
 */
export const syncMsgUnReadNum = (query) => {
  return axios.$get(`/api/member/myinfo/sync/unReadNum${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 翻译接口
 * @param {*} param {text: '', to: 'zh-CN'}
 * @returns {Object} {"code":0,"msg":"成功","data":{"from":"zh","to":"en","trans_result":{"dst":"The other party is not online, please try again later","src":"对方不在线，请稍后重试"}}}
 */
export const transform = (param) => {
  return axios.$post('api/translation/xf', param)
}
